import ndCourses from '../../assets/files/ndcourses.pdf'
// import ndSchools from '../../assets/files/ndschools.pdf'

export const polyMonoData = [
    {
    categoryTitle: 'POLYTECHNICS AND MONOTECHNICS',
    contentSection: [
        {
            id: 0,
            contentSectionName: 'List of Courses (POLYTECHNICS AND MONOTECHNICS)',
            contentPdf: ``,
            contentFile: ndCourses,
        },
        // {
        //     id: 1,
        //     contentSectionName: 'List of Schools',
        //     contentPdf: ``,
        //     contentFile: ndSchools,
        // },
        {
            id: 2,
            contentSectionName: 'List of Schools',
            pageTile: `POLYTECHNICS AND MONOTECHNICS`,
            desc: [
                `Listed in this Chapter are the Polytechnics and Monotechnics in Nigeria and obtainable Programmes. Candidates are strongly advised to carefully study the 
                requirements set out in this Chapter of this Brochure before selecting any of the Programmes.`,
                `Listed below are the names of Polytechnics in Nigeria. The abbreviations indicated against them are the ones used in this Brochure.`
            ],
            sections: [
                {
                    id: 1,
                    sectionTitle: `A. FEDERAL POLYTECHNICS`,
                    contents: [
                        {
                            abbreviation: `AFIT`,
                            instName: `Air Force Institute of Technology, Nigerian Air Force,`,
                            instAddress: `P.M.B. 2104, Mando, Kaduna`,
                            instPhone: [``],
                            email: [`registrar@afit.edu.ng`],
                            website: [`www.atit.edu.ng`]
                        },
                        {
                            abbreviation: `ADONS`,
                            instName: `Aliko Dangote College of Nursing ScIence`,
                            instAddress: `Bauchi, Bauchi State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AUCHIPOLY`,
                            instName: `Auchi Polvtechnic.`,
                            instAddress: `P. M. B. 13, Auchi. Edo State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-ADO`,
                            instName: `Federal Polvtechnic, Ado-Ekiti,`,
                            instAddress: `P. M. B. 5351, Ado-Ekiti, Ekiti State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-AIU`,
                            instName: `Akanu biam Federal Polvtechnic. Unwana`,
                            instAddress: `P.M.B. 1007, Afikpo, Ebonvi State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-BAL`,
                            instName: `Federal Polvtechnic Rah`,
                            instAddress: `P.M.B. 05, Bali, Taraba State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-BAU`,
                            instName: `Federal Polytechnic, Bauchi`,
                            instAddress: `P.M.B. 0231, Bauchi, Bauchi State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-BID`,
                            instName: `Federal Polytechnic, Bida`,
                            instAddress: `P. M. B. 55, Bida, Niger State`,
                            instPhone: [`066-461707`],
                            email: [`mohdbaba63@yahoo.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `FP-CR`,
                            instName: `Federal Polvtechnic Ugep`,
                            instAddress: `Cross River State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-DAM`,
                            instName: `Federal Polvtechnic`,
                            instAddress: `P. M.B. 1006. Damaturu. Yobe state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-DAURA`,
                            instName: `Federal Polvtechnic, Daura`,
                            instAddress: `Daura, Katsina State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-EDE`,
                            instName: `Federal Polytechnic, Ede`,
                            instAddress: `Ede, Osun State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-EKO`,
                            instName: `Federal Polytechnic, Ekowe`,
                            instAddress: `PMB 110 Yenagoa, bayelsa slate`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-OHODO`,
                            instName: `Federal Polytechnic Ohodo`,
                            instAddress: `Ohodo, Enugu State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-KALTUNGO`,
                            instName: `Federal Polytechnic, Kaltungo`,
                            instAddress: `Kaltungo, Gombe State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-IDA`,
                            instName: `Federal Polytechnic, Idah`,
                            instAddress: `P.M.B. 1037, Idah, Kogi State.`,
                            instPhone: [`058-800118`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-ILA`,
                            instName: `Federal Polytechnic, Ilaro.`,
                            instAddress: `P. M. B. 50, Ilaro, Ogun State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-MUB`,
                            instName: `Federal Polytechnic, Mubi`,
                            instAddress: `P.M.B. 35, Mubi, Adamawa state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-MONGUNO`,
                            instName: `Federal Polvtechnic, Monauno.`,
                            instAddress: `Monauno, Bauchi State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-NAM`,
                            instName: `Federal Polytechnic`,
                            instAddress: `P. M. B. 1012 Kaura Namoda, Zamtara State.`,
                            instPhone: [`063-60452.`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-NAS`,
                            instName: `Federal Polytechnic`,
                            instAddress: `P. M. B. 001, Nasarawa, Nasarawa State.`,
                            instPhone: [`047-66707`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-NEK`,
                            instName: `Federal Polytechnic, Nekede`,
                            instAddress: `P. M. B. 1036, Owerri, imo state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-OIL`,
                            instName: `Federal Polvtechnic of Oil and Gas, Bonny`,
                            instAddress: `Bonny, P.M.B. 5027, Rivers State`,
                            instPhone: [`08033363916`],
                            email: [`rector@fedpolybonny.edu.ng`],
                            website: [`tedpolybonny.edu.ng`]
                        },
                        {
                            abbreviation: `FEDPO-OFFA`,
                            instName: `Federal Polytechnic, Offa`,
                            instAddress: `P. M. B. 420, Otta, Kwara State`,
                            instPhone: [`031-801165`, `801043`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-OKO`,
                            instName: `Federal Polytechnic, Oko`,
                            instAddress: `Orumba North L.G.A. Anambra State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FP-OYO`,
                            instName: `Federal Polytechnic`,
                            instAddress: `Avede-Ogo Oluwa. Oyo State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-PLATEAU`,
                            instName: `Federal Polytechnic, Shendam.`,
                            instAddress: `Shendam, Plateau State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-OLUJI`,
                            instName: `Federal polytechnic, Ile-Oluji,`,
                            instAddress: `Ile-Oluji, mpetu resa Road, P.M.B. 727, Ile-Oluii Ondo State.`,
                            instPhone: [`08034729164`],
                            email: [`registrar@fedpolel.edu.ng`],
                            website: [`www.redpolel.org`]
                        },
                        {
                            abbreviation: `FEDPO-UGEP`,
                            instName: `Federal Polytechnic, Ugep`,
                            instAddress: `Ugep, Cross River State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-UKA`,
                            instName: `Federal Polytechnic, Ukana`,
                            instAddress: `P.M.B. 2014, Ukana, Essien Udim, Akwa bom State.`,
                            instPhone: [`08023572991`],
                            email: [`fedpolyukana@gmail.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDSTEN`,
                            instName: `Federal College of Dental lechnology and Therapy,`,
                            instAddress: `Enugu, Enugu, State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FTC-KAD`,
                            instName: `Federal Training Centre`,
                            instAddress: `Kaduna, Kaduna State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FTC-LAG`,
                            instAddress: `Federal Training Centre`,
                            instPhone: [`Ikoyi, Lagos State.`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KAD-POLY`,
                            instName: `Kaduna Polvtechnic. Kaduna`,
                            instAddress: `P. M. B. 2021, Kaduna, Kaduna State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDPO-KAZAURE`,
                            instName: `Hussaini Adam Federal Polytechnic`,
                            instAddress: `P.M.B. 5004, Kazaure, Jigawa state.`,
                            instPhone: [`08033334307`, `08038214729`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NACEST`,
                            instName: `Nigerian Army College of Environmental ScIence and lechnology,`,
                            instAddress: `P.M..B 102272 Makurdi, Benue State`,
                            instPhone: [`08070769011`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NASFA`,
                            instName: `Nigerian Army School of Finance and Administration,`,
                            instAddress: `Apapa Lagos.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NNFLC`,
                            instName: `Nigerian Navy Finance and Logistics College.`,
                            instAddress: `Naval Base. P.M.B. 9001, Owerrinta. Abia State.`,
                            instPhone: [`08078137259`],
                            email: [`info@nnflc.com.ng`],
                            website: [`www.nnflc.com.ng`]
                        },
                        {
                            abbreviation: `NICT`,
                            instName: `National Institute for Construction Technology`,
                            instAddress: `Uromi. Edo State`,
                            instPhone: [`+2348075961071`],
                            email: [`nicturomi@qmail.com.`, `onohaebi@qmail.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `NITT-ND`,
                            instName: `Nigerian Institute of Transport Technology, Zaria`,
                            instAddress: `Zaria Kaduna State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NICO`,
                            instName: `National Institute for Cultural Orientation`,
                            instAddress: `Lagos Training School. National Theatre Annex, lganmu, Lagos State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `WUFPOBK`,
                            instName: `Waziri Umaru Federal Polytechnic Birnin`,
                            instAddress: `Kebbi, Kebbi State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `YABATECH`,
                            instName: `Yaba College of Technology.`,
                            instAddress: `P. M. B. 2001, Yaba, Lagos State`,
                            instPhone: [`01-800160`],
                            email: [``],
                            website: [``]
                        },
                    ]
                },
                {
                    id: 2,
                    sectionTitle: `B. STATE POLYTECHNICS`,
                    contents: [
                        {
                            abbreviation: `AAP`,
                            instName: `Abraham Adesanya Polytechnic,`,
                            instAddress: `Dagbolu/Akanran/Ibadan Road Atikori, ljebu-Igbo P.M.B. 1020 ljebu-Igbo Ogun State`,
                            instPhone: [``],
                            email: [`aapolyijebuigbo@gmail.com`],
                            website: [`www.aapoly.edu.ng`]
                        },
                        {
                            abbreviation: `ABIAPOLY`,
                            instName: `Abia State Polvtechnic`,
                            instAddress: `P.M.B. 166, Aba, Abia State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ACHTECH`,
                            instName: `Abia State College of Health Sciences and Management Technology, Aba`,
                            instAddress: `P.M.B. 7016, Aba Abia State`,
                            instPhone: [`082232205`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AG-POLY`,
                            instName: `Abdu Gusau Polvtechnic.`,
                            instAddress: `Talata-Mafara, Zamfara State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AKPOLY`,
                            instName: `Akwa-Ibom State Polytechnic.`,
                            instAddress: `Ikot-Osurua P.M.B. 1200, Ikot-Ekpene, Akwa-Ibom State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ALOOMA`,
                            instName: `Mai Iris Alooma Polvtechnic.`,
                            instAddress: `P.M.B. 1020. Geidam, Yobe State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AKCAS`,
                            instName: `Ale Ihom State Collece of Arts and Science Nung`,
                            instAddress: `Nung Ikim Akwa lhom State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ANSPOLY`,
                            instName: `Anambra State Polvtechnic.`,
                            instAddress: `Mgbakwu, Anambra State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ATAPOLY`,
                            instName: `Abubakar Tatari Ali Polytechnic.`,
                            instAddress: `P. M. B. 0094, Bauchi, Bauchi State`,
                            instPhone: [`077-42196`, `42548`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BEN-POLY`,
                            instName: `Benue State Polvtechnic.`,
                            instAddress: `Uabokolo P. M. B. 2215, Otukpo, Benue State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BUPOLY-HAD`,
                            instName: `Binvamina Usman Polvtechnic, Hadejia,`,
                            instAddress: `KM 8, Near Yamidi Village, P.M.B. 013, Hadeiia Jiaawa State.`,
                            instPhone: [``],
                            email: [`jiagricollege@yahoo.co.uk`],
                            website: [``]
                        },
                        {
                            abbreviation: `BYSPOLY`,
                            instName: `Bavelsa State Polytechnic.`,
                            instAddress: `P.M.B. 168, Aleibiri, Ekeremor, Bayelsa State.`,
                            instPhone: [`07034747835`, `08070574835`],
                            email: [`rectorbycas2@gmail.com`],
                            website: [`www.bvcas.edu.na`]
                        },
                        {
                            abbreviation: `CABSP`,
                            instName: `College or Administrative and Business Studies Potiskur`,
                            instAddress: `P.M.B. 1001. Potiskum. yobe State`,
                            instPhone: [`074-420067`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CHST-IJERO`,
                            instName: `College of Health Sciences and Technology`,
                            instAddress: `Ijero-Ekiti, P.M.B. 316`,
                            instPhone: [``],
                            email: [``],
                            website: [`www.cohealthechilero.org`]
                        },
                        {
                            abbreviation: `COH-EBONY™`,
                            instName: `College of Health Technology, Ezzangbo,`,
                            instAddress: `Ezzangbo, Ebonvi State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `D.S. ADEGBENRO`,
                            instName: `D. S. Adegbenro ICT Polytechnic, Itori,`,
                            instAddress: `Itori, Ogun State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EKITI-POLY`,
                            instName: `Ekiti State Polytechnic,`,
                            instAddress: `san-Ekiti`,
                            instPhone: [``],
                            email: [`rector@catis.edu.ng`],
                            website: [``]
                        },
                        {
                            abbreviation: `ENU-POLY`,
                            instName: `Enugu State Polytechnic,`,
                            instAddress: `Iwollo. Ezeaau LGA. Enugu State.`,
                            instPhone: [`07036881142`, `08104353744`],
                            email: [`espolyregistrar@gmail.com`],
                            website: [`www.espoly.edu.ng`]
                        },
                        {
                            abbreviation: `GSPB`,
                            instName: `Gombe State Polvtechnic.`,
                            instAddress: `Bajoga, Gombe State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `IBD-POLY`,
                            instName: `The Polvtechnic. Ibadan.`,
                            instAddress: `P.M.B. 22, Ibadan. Oyo State`,
                            instPhone: [`08133356769`, `08133356895`],
                            email: [`rector@polyibadan.edu.ng`],
                            website: [`www.polyibadan.edu.ng`]
                        },
                        {
                            abbreviation: `IMO-POLY`,
                            instName: `Imo State Polytechnic, Umuagwo.`,
                            instAddress: `Umuagwo, Ohaji, PMB 172 Owerri Imo State`,
                            instPhone: [`08107684665`],
                            email: [`icthelpdesk@imopoly.edu.ng`],
                            website: [`www.imopolv.edu.na`]
                        },
                        {
                            abbreviation: `IMT-ENU`,
                            instName: `Institute of Management and Technology, Enugu`,
                            instAddress: `P.M.B. 1079, Enugu Enugu State`,
                            instPhone: [`042-251145`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `INSPOTECH`,
                            instName: `Inspire Polytechnic,`,
                            instAddress: `Lagos, Lagos State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ITM-UGEP`,
                            instName: `Institute of Technologv and Management,`,
                            instAddress: `Calabar - Ikom High Way, Ugep, Cross RIVer State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `JIG-POLY`,
                            instName: `Jigawa State Polytechnic, Dutse`,
                            instAddress: `Block 40-42, Old Secretariat P.M.B. 7040 Dutse Jigawa State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KAN-POLY`,
                            instName: `Kano State Polvtechnic.`,
                            instAddress: `P.M.B. 3401, Kano, Kano State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KAT-POLY`,
                            instName: `Hassan Usman Katsina Polytechnic.`,
                            instAddress: `P.M.B. 2052, Katsina, Katsina State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KSITM-ND`,
                            instName: `Katsina State institute of Technology and Management (ND),`,
                            instAddress: `Katsina State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KOGI-POLY`,
                            instName: `Kogi State Polytechnic, Lokoja,`,
                            instAddress: `Kogi State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KONDUGA`,
                            instName: `College of Business and Management Studies.`,
                            instAddress: `Konduga, Borno State`,
                            instPhone: [``],
                            email: [`cobamaskonduga@gmail.com`, `dalumamuhammad@amai.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `KWA-POLY`,
                            instName: `Kwara State Polytechnic`,
                            instAddress: `P.M.B. 1375,ilorin. Kwara state`,
                            instPhone: [`+234 (0) 8107431087`],
                            email: [`contact@kwarapolytechnic.com`],
                            website: [`www.kwarapoly.edu.ng`]
                        },
                        {
                            abbreviation: `LASPOTECH`,
                            instName: `Lagos State Polytechnic,`,
                            instAddress: `P.M.B. 21606, Ikeja Lagos State`,
                            instPhone: [`01-523528.`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MAPOLY`,
                            instName: `Moshood Abiola Polytechnic.`,
                            instAddress: `Abeokuta, Ogun State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `IMA-POLY`,
                            instName: `sa Mustapha Agwal Polytechnic`,
                            instAddress: `P. M. B. 109, Lafia, Nasarawa state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NBPZ`,
                            instName: `Nuhu Bamalli Polytechnic`,
                            instAddress: `P.M.B. 1061, Zaria, Kaduna sтате.`,
                            instPhone: [`069-334050`, `333031`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `OGWASHIUKU`,
                            instName: `Delta State Polvtechnic`,
                            instAddress: `Ogwashi-Uku, Isele-Azagba Road, Ogwashi-Uku, Delta State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `OGITECH`,
                            instName: `Ogun State Institute of Technology (formerly Gateway ICT Polytechnic), labesa`,
                            instAddress: `Oba Adesola Market Road Igbesa Ogun State, Nigeria`,
                            instPhone: [`+234(0)8035593591`, `+234(0)8168367794`],
                            email: [`info@ogitech.edu.ng`],
                            website: [`www.ogitech.edu.ng`]
                        },
                        {
                            abbreviation: `OKE-OGUN POLY`,
                            instName: `The Oke-Ogun Polytechnic`,
                            instAddress: `P.M.B. 021, Saki, Oyo State.`,
                            instPhone: [`08059831225`, `08055112409`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `OTEFE`,
                            instName: `Delta State Polytechnic, Otefe,`,
                            instAddress: `P.M.B. 03, Oghara. Delta State`,
                            instPhone: [`054-340500`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `OSUNPOLY`,
                            instName: `Osun State Polytechnic, Iree`,
                            instAddress: `P.M.B. 301, Iree, Osun State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `OSUNTECH`,
                            instName: `Osun State College of Tech, Esa-Oke`,
                            instAddress: `P.M.B. 1011 Esa-Oke Osun State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `OYSCATECH`,
                            instName: `Oyo State college ot Agriculture and Technology, Igbo-Ora`,
                            instAddress: `P.M.B. 10, Igbo-Ora, Oyo State`,
                            instPhone: [`0803-3890972`, `08059947661`],
                            email: [`lasunfarinu@yahoo.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `OZORO`,
                            instName: `Delta State Polytechnic, Ozoro`,
                            instAddress: `P.M.B. 5, Uzoro, Delta state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `PH-POLY`,
                            instName: `Port Harcourt Polytechnic`,
                            instAddress: `P.M.B. 5936.Rumuola Port Harcourt Rivers State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `PLS-POLY`,
                            instName: `Plateau State Polytechnic, Barkin-Ladi`,
                            instAddress: `P. M. B. 02023, Bukuru, Plateau State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `POLY-OMUO`,
                            instName: `The Polvtechnic, Omuo-Ekiti,`,
                            instAddress: `Ekiti State/`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `POLY-OJOKU`,
                            instName: `The Polvtechnic. Ojoku,`,
                            instAddress: `Ojoku,, Kwara State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `POLY-YOLA`,
                            instName: `Adamawa State Polytechnic.`,
                            instAddress: `P.M.B. 2146, Yola, Adamawa State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `RAMATPOLY`,
                            instName: `Ramat Polytechnic`,
                            instAddress: `P. M.B. 1017, Maiduguri, Borno State`,
                            instPhone: [`09025926599`, `08065496112`],
                            email: [`info@ramatpoly.edu.ng`],
                            website: [``]
                        },
                        {
                            abbreviation: `RIVCOST`,
                            instName: `Rivers State College of Health Science`,
                            instAddress: `KM 6, Ikwerre Road, Rumueme P.M.B. 5039. Port Harcourt Rivers tate`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `RUGIPO`,
                            instName: `Rufus Giwa Polytechnic`,
                            instAddress: `P.M.B. 1019, Owo, Ondo state.`,
                            instPhone: [`051-241433`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `RUFAI-ND`,
                            instName: `A.D Rutai College of Education, Legal & General Studies (ND)`,
                            instAddress: `Misau. Bauchi State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SAAPADE`,
                            instName: `Gateway ICT Polytechnic,`,
                            instAddress: `Gateway ICT Polytechnic, Saapade, Ogun State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SARO-WIWA POLY`,
                            instName: `Kenule Beeson Saro-Wiwa Polvtechnic`,
                            instAddress: `P.M.B. 20, Bori, Rivers State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `TAR-POLY`,
                            instName: `Taraba State Polytechnic.`,
                            instAddress: `Suntai, Taraba State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AO-POLY`,
                            instName: `Adeseun Ogundoyin Polytechnic, Eruwa,`,
                            instAddress: `P.M.B. 1015, Eruwa, Oyo State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UAS-POLY`,
                            instName: `Umar Ali Shinkafi Polytechnic, Central Administration Otice`,
                            instAddress: `Airport Road, Farfaru, P.M.B. 2356. Sokoto`,
                            instPhone: [`060-231364`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `USEN`,
                            instName: `Edo State Polytechnic, Usen`,
                            instAddress: `P.M.B., 1104, Benin City Edo State, Nigeria`,
                            instPhone: [`07030863183`, `07035147942`],
                            email: [`registrar@esitmusen.edu.ng`],
                            website: [``]
                        },
                        {
                            abbreviation: `ZUNGERU`,
                            instName: `Niger State Polytechnic,`,
                            instAddress: `Zungeru, Niger State`,
                            instPhone: [`066-710380`],
                            email: [``],
                            website: [``]
                        },
                    ]
                },
                {
                    id: 3,
                    sectionTitle: `C. POLYTECHNICS WITH NCE PROGRAMMES`,
                    contents: [
                        {
                            abbreviation: `ATAPOLY-ED`,
                            instName: `Abubakar Tatari Ali Polytechnic`,
                            instAddress: `Bauchi State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KATPOLY-ED`,
                            instName: `Hassan Usman Katsina Polytechnic`,
                            instAddress: `Katsina`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KADPOLY-ED`,
                            instName: `Kaduna Polvtechnic`,
                            instAddress: `Kaduna State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KANPOLY-ED`,
                            instName: `Kano State Polytechnic`,
                            instAddress: `Kano`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NBPZ-ED`,
                            instName: `Nuhu Bamalli Polytechnic`,
                            instAddress: `Zaria, Kaduna State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `OSUNPO-ED`,
                            instName: `Osun State Polvtechnic`,
                            instAddress: `Iree, Osun State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `PLSPOLY-ED`,
                            instName: `Plateau State Polytechnic`,
                            instAddress: `Barkin-Ladi, Plateau State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `RAMATPOLY-ED`,
                            instName: `Ramat Polytechnic`,
                            instAddress: `Maiduguri State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `WUFPOBK-ED`,
                            instName: `Waziri Umaru Federal Polytechnic`,
                            instAddress: `Birnin Kebbi, Kebbi State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                    ]
                },
                {
                    id: 4,
                    sectionTitle: `D. PRIVATE POLYTECHNICS`,
                    contents: [
                        {
                            abbreviation: `AJAYI-POLY`,
                            instName: `Ajayi Polytechnic`,
                            instAddress: `Ado/Ikere Express Way, Ikere-Ekiti Ekiti State.`,
                            instPhone: [`09066828205`, `09066893904`, `08125273424`],
                            email: [`rector@ajayipolytechnic.edu.ng`, `info@ajayipolytechnic.edu.ng`],
                            website: [``]
                        },
                        {
                            abbreviation: `AL-HIKMA-P`,
                            instName: `Al-Hikma Polytechnic`,
                            instAddress: `1st Close, Off Tafawa Balewa Street, Behind Ahmad In Abubakar Mosque, P.O. Box 453, Mararaba, LEaSarAWA State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ALLOVER-POLY`,
                            instName: `Allover Central Polytechnic`,
                            instAddress: `Lynson Chemical Avenue, Off Idiroko Road, P.O Box 1518, Ota, Ogun State.`,
                            instPhone: [`08037707000`, `08055204560`],
                            email: [`alloverpolytechnic1@yahoo.com`],
                            website: [`www.alloverpolytechnic.com`]
                        },
                        {
                            abbreviation: `APS`,
                            instName: `Abula schoo of rension and Retirement Planning`,
                            instAddress: `The Heritage House Plot 636a, Sultan Abubakar Way, Wuse Zone 3, Abuja,`,
                            instPhone: [`+23492912242`],
                            email: [`info@aps.edu.ng`],
                            website: [`www.apseduc.org`]
                        },
                        {
                            abbreviation: `POLY-ARAN`,
                            instName: `The Polytechnic, Aran-Orin,`,
                            instAddress: `Aran-Orin, Kwara State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ASHI-POLY`,
                            instName: `Ashi Polytechnic`,
                            instAddress: `Anyiin, Logo, P.M.B 102098, Benue State.`,
                            instPhone: [`:08020532524`, `07054087111`],
                            email: [`ashitechnigltd2007@gmail.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `ATLAS-IMT`,
                            instName: `Atlas Institute of Management and Technology`,
                            instAddress: `Eluama Uzuakoli, Abia State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BELLARKS`,
                            instName: `Bellarks Polytechnic,`,
                            instAddress: `Kwale, Delta State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BOLMOR-POLY`,
                            instName: `Bolmor Polytechnic`,
                            instAddress: `33, Old Ife Road, P.M.B. 32, Agodi, Ibadan, Oyo State.`,
                            instPhone: [`08030650707`, `08029928528`],
                            email: [`bolmorpolytechnic@yahoo.com`],
                            website: [`www.bpi.edu.nd`]
                        },
                        {
                            abbreviation: `BESTPOTECH`,
                            instName: `Best Solution Polytechnic`,
                            instAddress: `Akure, Ondo State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BRAINFILL`,
                            instName: `Brainfill Polytechnic`,
                            instAddress: `Ikot Ekpene, Akwa Ibom State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CALVARYPOLY`,
                            instName: `Calvary Polytechnic`,
                            instAddress: `Owa-Oyibu, Delta State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CC-TECH`,
                            instName: `Commonwealth College of Technology`,
                            instAddress: `Gboko, Benue State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CITIPOLY`,
                            instName: `Citi Polytechnic`,
                            instAddress: `Plot 182, Hillside Extension, Dutsen Dawaki Road, Abuja.`,
                            instPhone: [`08037879854`, `08055256245`,],
                            email: [`citipolytechnicabuja.edu.ng`],
                            website: [``]
                        },
                        {
                            abbreviation: `COVENANT-POLY`,
                            instName: `Covenant Polytechnic`,
                            instAddress: `168 Aba/owerri Road, Aba P.M.B. 7065 Abia, Abia State`,
                            instPhone: [`08055929054`, `08055929077`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `COASTAL`,
                            instName: `Coastal Polytechnic`,
                            instAddress: `Apapa, Lagos State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CROWN`,
                            instName: `Crown Polytechnic,`,
                            instAddress: `P.M.B 54424, Ilawe Road, Odo Ado-Ekiti, Ekiti State`,
                            instPhone: [`olukowadeo@yahoo.com`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CRESTFIELD-CHT`,
                            instName: `Crestfield College of Health Technology,`,
                            instAddress: `Erin Osun, Osun State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `POLY-IRESI`,
                            instName: `The Polytechnic, Iresi`,
                            instAddress: `P.O. Box 5, Iresi, Boluwaduro L.G.A., Usun state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `DANSHARIF-CNS`,
                            instName: `Dansharif College of Nursing Sciences.`,
                            instAddress: `Kano, kano State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `DORBEN`,
                            instName: `Dorben Polytechnic`,
                            instAddress: `Bwari-Garam Road P.O.Box 590,Garki, Abuja FCT.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EASTERN-POLY`,
                            instName: `Eastern Polytechnic`,
                            instAddress: `34, Ogboroama Street, Rumuokwurusi. Port Harcourt, Rivers State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ECP`,
                            instName: `Ekiti City Polytechnic,`,
                            instAddress: `Omuooke, Ekiti State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EKO-POLY`,
                            instName: `Eko College of Management and Technology (POLY),`,
                            instAddress: `kotun, Lagos State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ENVILLETECH`,
                            instName: `Enville Institute of Management & Technology`,
                            instAddress: `Iganke Village, Off Iganke/Itokin Road, Epe LGA, Lagos State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FIDEIPOLY`,
                            instName: `Fidei Polytechnic, Gboko`,
                            instAddress: `P.M.B. 185, KM 8 Gboko-Aliade Road Benue State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FOUNDATION`,
                            instName: `Foundation Polytechnic, Ikot Idem,`,
                            instAddress: `Ikot Ekpene, Akwa-bom State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `GBOKO-POLY`,
                            instName: `Gboko Polytechnic`,
                            instAddress: `P.M.B. 131, Gboko. Benue State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `GLOBALPOLY`,
                            instName: `Global Polytechnic`,
                            instAddress: `Oyemekun Road, P.M.B. 1067, Akure, Ondo State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `GLORYLAND-POLY`,
                            instName: `Gloryland Polytechnic`,
                            instAddress: `Ankpa, Kogi State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `GRACE-POLY`,
                            instName: `Grace Polytechnic`,
                            instAddress: `9 Joseph Shyngle Close, Off James Robertson Street, Alhai Masha Surulere, P.M.B. 9067, Lagos`,
                            instPhone: [`08032177275`, `08023225962`],
                            email: [`gracepoly@yahoo.com`],
                            website: [`www.gracepoly.net`]
                        },
                        {
                            abbreviation: `GRACELAND`,
                            instName: `Graceland Polytechnic`,
                            instAddress: `P.O. Box 598, Oyeleke College Road, Off Ira Road, Offa, Kwara State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `GRUNDTVIG`,
                            instName: `Grundtvig Polytechnic`,
                            instAddress: `KM 11, Onitsha-Owerri Road, Oba, Anambra State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `HARRY-PASS`,
                            instName: `Harry Pass Polytechnic, Tse Usen Mkar`,
                            instAddress: `Gboko, Benue State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `HARVARDE`,
                            instName: `Harvarde College of Management and Business Studies,`,
                            instAddress: `Abeokuta, Ogun State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `HARVARD-POLY`,
                            instName: `Harvard Polytechnic`,
                            instAddress: `No 15, Onireke Road, Agbabiaka, Torin- Kwara state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `HERITAGE`,
                            instName: `Heritage Polytechnic`,
                            instAddress: `Ikot Udota, P. O. Box 1029, Eket, Akwa Ibom State.`,
                            instPhone: [`08052557099`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `HOPE-POLY`,
                            instName: `Hope Polvtechnic`,
                            instAddress: `Ndon Utibe, Ikono, Akwa Ibom State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `IBADAN-CITYPOLY`,
                            instName: `Ibadan City Polytechnic`,
                            instAddress: `P.M.B. 10426, Dugbe, ibadan`,
                            instPhone: [`07084593012`],
                            email: [`citypolytechnicibadan@gmail.com`],
                            website: [`www.ibadancitypolytechnic.com`]
                        },
                        {
                            abbreviation: `IBOM-POLY`,
                            instName: `Ibom Metropolitan Polytechnic`,
                            instAddress: `Attan Offot, Uyo, Akwa Ibom State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ICON-POLY`,
                            instName: `1-CON Universal Polytechnic`,
                            instAddress: `Osogbo, Osun State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `IGBAJO-POLY`,
                            instName: `Igbajo Polytechnic`,
                            instAddress: `P.M.B. 303 Igbajo, Osun State.`,
                            instPhone: [`08033600739`],
                            email: [`igbojopolytechnic@gmail.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `IGBO-OWU POLY`,
                            instName: `The Polytechnic, Igbo-Owu`,
                            instAddress: `Off Asa dam/Osere Road junction Box 799. Ilorin Kwara State.`,
                            instPhone: [`08033920894`, `08097960313`, ``],
                            email: [`thepolytechnicigboowu@yahoo.com`, `thepolytechnicigboowu@gmail.com`],
                            website: [`www.thepolvtechniciaboowu.edu.ng`]
                        },
                        {
                            abbreviation: `ILE-IFE`,
                            instName: `The Polytechnic, Ile-Ife`,
                            instAddress: `NITEL Road, P. M. B. 009, 0. A. U. Post Office, e-te. Osun State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `INTERLINK`,
                            instName: `Interlink Polytechnic`,
                            instAddress: `P.M.B. 5060, ljebu-Jesa, Osun State Nigeria`,
                            instPhone: [`02-2020999`, `08030660749`],
                            email: [`registry@interlinkpolvtechnic.org`],
                            website: [`www.interlinkpolytechnic.org`]
                        },
                        {
                            abbreviation: `IWO-POLY`,
                            instName: `Iwo City Polytechnic`,
                            instAddress: `Iwo, Osun State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KALAC`,
                            instName: `Kalac Christal Polytechnic`,
                            instAddress: `Sango-Tedo, Lekki, Lagos State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KINGS-POLY`,
                            instName: `Kings Polytechnic`,
                            instAddress: `Ubiaja Edo State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `LAG-CITY`,
                            instName: `Lagos City Polytechnic`,
                            instAddress: `Ikeja, Lagos State.`,
                            instPhone: [`01-4970455`, `960543`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `LENS-POLY`,
                            instName: `Lens Polytechnic`,
                            instAddress: `Km 2, Irra Road, Offa, Kwara State`,
                            instPhone: [`07066401958`, `08035705289`],
                            email: [``],
                            website: [`www.lenspolytechnic.edu.ng`, `www.lenspolytechnic.com`]
                        },
                        {
                            abbreviation: `LIGHTHOUSE`,
                            instName: `Light House Polytechnic`,
                            instAddress: `Evboabanuosa Kilometre 32, Benin -Asaba Express Way, P.M.B. 1004, Benin City Edo State`,
                            instPhone: [``],
                            email: [`lighthousepoly @yahoo.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `LNDMK-POLY`,
                            instName: `Landmark Polytechnic`,
                            instAddress: `Ayetoro, Ogun State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `LOAM-POLY`,
                            instName: `Loam Polvtechnic.`,
                            instAddress: `Ikono. Akwa-Ibom State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MARIST`,
                            instName: `Marist Polytechnic`,
                            instAddress: `Umuchigbo-De Nike Emene, Enugu. Enugu State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MATER-DEI`,
                            instName: `Mater Dei Polytechnic`,
                            instAddress: `Ogwuoba Town, Oji River, Enugu State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MUSTIBRAH`,
                            instName: `Mustibrah College of Information Technology and Management Studies,`,
                            instAddress: `Kano, Kano State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NACABSPOLY`,
                            instName: `NACABS Polytechnic`,
                            instAddress: `Nacabs Road, Wamba Bye-Pass, P.M.B 011, Akwanga, Nasarawa State,`,
                            instPhone: [`08035922831`, `08033219379`],
                            email: [`nacabsedu2000@gmail.com`],
                            website: [`www.nacabspoly.net.ng`]
                        },
                        {
                            abbreviation: `NEWLAND`,
                            instName: `Newland Polytechnic`,
                            instAddress: `Idofian, Kwara State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NOGAK`,
                            instName: `Nogak Polytechnic`,
                            instAddress: `Mile 2 Road, State Housing, P.M.B. 1078, kom, Cross River State.`,
                            instPhone: [`08030529323`, `08185701977`],
                            email: [`ernegodo@vahoo.com`],
                            website: [`www.nogakpolytechnic.org`]
                        },
                        {
                            abbreviation: `NOVELTY`,
                            instName: `Novelty Polytechnic`,
                            instAddress: `KM 3, Kishi llorin Road, Oyo State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NANA-BABAJO-CNM`,
                            instName: `Nana Babajo College of Nursing and Midwifery`,
                            instAddress: `Malumfashi, Katsina State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ODUWA-POLY`,
                            instName: `Oduduwa Polytechnic`,
                            instAddress: `Idumu, Lagos State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `OSISATECH`,
                            instName: `Our Saviour Institute of Science, Agriculture and Technology (Poly)`,
                            instAddress: `Enugu, Enugu State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `PARAMOUNT`,
                            instName: `Paramount Polytechnic`,
                            instAddress: `Ejigbo, Lagos State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `PARLIAMENT-CHST`,
                            instName: `Parliament College of Health Science and technology`,
                            instAddress: `Yauri, Kebbi State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `POLY-IMESI`,
                            instName: `The Polytechnic, Imesi-lle`,
                            instAddress: `Imesi-lle P.M.B. 001, Imesi-lle, Osun State.`,
                            instPhone: [`08034445885`, `08077787786`, `08057680790`, `08023239168`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `POLY-ADOKA`,
                            instName: `The Polytechnic, Adoka`,
                            instAddress: `Adoka, Benue State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `PRIME-POLY`,
                            instName: `Prime Polytechnic`,
                            instAddress: `Jidda Bassa, Ajaokuta, Kogi State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `QUEST`,
                            instName: `Quest for Knowledge International School,`,
                            instAddress: `Mararaba, Nasarawa state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `RECTEM`,
                            instName: `Redeemer's College of Technology and Management`,
                            instAddress: `Redemption Camp, KM 46, Lagos- Ibadan Express Way, Ogun State`,
                            instPhone: [`07037525789`],
                            email: [`admin@ rectem.edu.ng`],
                            website: [`www.rectem.edu.ng`]
                        },
                        {
                            abbreviation: `RONIK`,
                            instName: `RONIK Polytechnic`,
                            instAddress: `23-25, Ailegun Road, Off Ejigbo/Egbe Road, P.M.B. 21764, Ikeja - Lagos.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SAYACOES`,
                            instName: `Sani Yar'adua College of Environment Studies`,
                            instAddress: `Kastina, Kastina State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SA-POLY`,
                            instName: `Southern Atlantic Polytechnic`,
                            instAddress: `Uyo, Akwa Ibom State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SAF-POLY`,
                            instName: `SAF Polytechnic`,
                            instAddress: `Iseyin, P.O. Box 55, Oyo State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SHAKA`,
                            instName: `Shaka Polytechnic.`,
                            instAddress: `1, Prince Shaka Momodu Stret, Ogiso, Off Muritala Mohammed Way, P.M.B. 1240, Benin City, Edo State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SPEEDWAY`,
                            instName: `Speedway Polytechnic Osoba`,
                            instAddress: `5/7/17, Igbehinadun Street, off Odozi Street, Saabo, Ojodu Berger, Ogun State,`,
                            instPhone: [`08094799878`, `08064654535`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ST MARY-POLY`,
                            instName: `St. Mary Polytechnic`,
                            instAddress: `Kwamba. Suleja, Niger State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `STARS-POLY`,
                            instName: `Stars Polytechnic`,
                            instAddress: `Agbedi-Atan, Ogun State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SURE-POLY`,
                            instName: `Sure Foundation Polytechnic`,
                            instAddress: `Ikot Akai, Ukanafun LGA, Akwa hom State`,
                            instPhone: [`08064257940`, `08168338559`],
                            email: [`surefoundation.edu@gmail.com`],
                            website: [`www.sfp.edu.ng`]
                        },
                        {
                            abbreviation: `TIMKAI`,
                            instName: `Timeon Kairos Polytechnic`,
                            instAddress: `Abule Egba, Lagos State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `TEMPLE-GATE`,
                            instName: `Temple-Gate Polytechnic`,
                            instAddress: `P.O.Box 3448, Aba Abayi, Osisioma, Abla state`,
                            instPhone: [`_2348037102981`, `0802350396`],
                            email: [`tempegatepoly@yahoo.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `TOWER-POLY`,
                            instName: `Tower Polytechnic`,
                            instAddress: `Ire Akari Estate Campus, off New Garage Express Way, Oluyole Extension, Ibadan. Ago Taylor Campus,40, Abeokuta Rd., Fatimo Bus-stop, Odo-ana P.O. Box 13039, Ibadan, Oyo State.`,
                            instPhone: [`08037276613`],
                            email: [`info@towerpolytechnic.edu.ng`],
                            website: [`www.towerpolytechnic.edu.ng`]
                        },
                        {
                            abbreviation: `TRINITY`,
                            instName: `Trinity Polytechnic`,
                            instAddress: `Mbak Road, Ifa Arai, Uyo, Akwa Ibom State.`,
                            instPhone: [`08025811277`, `08059358593`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UEC-TECH`,
                            instName: `Ultra-Excellence College of Technology`,
                            instAddress: `Uyo, Akwa Ibom State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UNI-POLY`,
                            instName: `United Polytechnic`,
                            instAddress: `Gamajigo, Off KM 7, Zaria Road, Jos- Plateau Plateau State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UMA-UKPAI`,
                            instName: `Uma Ukpai Polytechnic`,
                            instAddress: `Osaga Ohafia, Abia State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UYO-CITYPOLY`,
                            instName: `Uyo City Polytechnic`,
                            instAddress: `P.M.B. 1067, Uyo, Akwa Ibom State.`,
                            instPhone: [`080233371245333`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `VALLEY VIEW`,
                            instName: `Valley View Polytechnic`,
                            instAddress: `Ohafia, Abia State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `WESTLAND-POLY`,
                            instName: `Westland Polytechnic`,
                            instAddress: `llobu, Osun State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `WOLEX`,
                            instName: `Wolex Polytechnic`,
                            instAddress: `1 Ogun Street, Adealu Bus Stop, Lagos - Abeokuta Express Way Dopemu, P. O. Box 1520, Ikeja - Lagos.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                    ]
                },
                {
                    id: 5,
                    sectionTitle: `E. FEDERAL MONOTECHNICS`,
                    contents: [
                        {
                            abbreviation: `SHIM-ATBUTH`,
                            instName: `Schoo or Heath information Management`,
                            instAddress: `Abubakar Tafawa Balewa University Teaching Hospital. Bauchi. Bauchi State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CN-GWAGWALADA`,
                            instName: `Fct College of Nursing`,
                            instAddress: `Gwaawaalada. Abuja-Fct.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `COLAGRIC-ZAR`,
                            instName: `Samaru college of Agriculture, Division of Agricultural Colleges, Ahmadu bello Universitv. Zaria.`,
                            instAddress: `P.M.B. 1058, Zaria Nigeria`,
                            instPhone: [`069-551113`],
                            email: [`provostscadac@abu.edu.ng`],
                            website: [``]
                        },
                        {
                            abbreviation: `CVMLT`,
                            instName: `Federal College of veterinary and Medical Laboratory Technology`,
                            instAddress: `vom, Plateau State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FCAPT-KANO`,
                            instName: `Federal College of Agricultural Produce Technology`,
                            instAddress: `Plot 54-56 CBN Road, Hotoro G.R.A. Extension, P.M.B. 3013, Kano, Kano State.`,
                            instPhone: [`064-319047`, `08037037095`],
                            email: [`fcatkano@yahoo.com`, `nsprikano@yahoo.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `FECOT`,
                            instName: `Federal College of Orthopaedic Technology`,
                            instAddress: `Igbobi, Lagos P.M.B. 2009, Yaba, Lagos State`,
                            instPhone: [``],
                            email: [`fecotlagos @gmail.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDAGRIC-IBD`,
                            instName: `Federal College of Agriculture. Moor Plantation,`,
                            instAddress: `P. M. B. 5029, Ibadan, Oyo State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDAGRIC-ISH`,
                            instName: `Federal College of Agriculture. Ishiaau.`,
                            instAddress: `P. M. B. 7008, Ishiagu, Ebonvi State`,
                            instPhone: [`07088929281`,`08033707901`,`08072874619`],
                            email: [`fcaiebonyi@yahoo.com`, `ajapaulo@yahoo.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDAGRIC-AKR`,
                            instName: `Federal College of Agriculture, Ado_Ekiti`,
                            instAddress: `Ado_EkitiOwe Road Akure. Ondo State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDCO-ED`,
                            instName: `Federal College of Forest Resources Management.`,
                            instAddress: `Fugar, Edo State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDCO-ISHI`,
                            instName: `Federal College of Forest Resources Management.`,
                            instAddress: `Ishiagu. Ebonyi State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDCO-MAID`,
                            instName: `Federal Collece of Eorest Resources Management.`,
                            instAddress: `Maiduguri, Borno State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDANIM-VOM`,
                            instName: `Federal College of Animal Health and Production Technoloav.`,
                            instAddress: `P. M. B. 1. Vom Plateau State`,
                            instPhone: [`08088953328`, `07089290016`],
                            email: [`fcahptvomvet@amail.com`, `provost@tcahptvomvet.edu.na`],
                            website: [`www.rcanotvomvet.edu.ng`]
                        },
                        {
                            abbreviation: `FEDANIM-IBD`,
                            instName: `Federal College of Animal Health and Production Technology,`,
                            instAddress: `P. M. B. 5029. Ibadan Ovo State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDCOOP-IBD`,
                            instName: `Federal Cooperative College, Ibadan`,
                            instAddress: `P.M.B. 5033, Eleyele, Ibadan, Oyo State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDCOOP-ORJI`,
                            instName: `Federal Cooperative College, Oji River`,
                            instAddress: `P.M.B. 017, Oji-River Enugu State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDCOOP-KD`,
                            instName: `Federal Cooperative College, Kaduna`,
                            instAddress: `Abuja Read Inction P.M.B. 2425 Kaduna Kaduna State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDFISH-BAGA`,
                            instName: `Federal College of Freshwater Fisheries Technology, Baga`,
                            instAddress: `P.M.B. 1060, Maiduguri`,
                            instPhone: [`08053417959`, `08025947357`, `08050305033`, `08026477321`],
                            email: [`bagafishcol@yahoo.com`, `femidaddy@yahoo.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDFISH-NBUS`,
                            instName: `Federal College of Freshwater Fisheries Technology`,
                            instAddress: `P. M. B. 1500, New Bussa Niger State`,
                            instPhone: [`08036067694`, `08057052610`, `08100347755`],
                            email: [`fefftnewbussa@yahoo.com`, `fefftnewbussa@qmail.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDCOFM-AFAKA`,
                            instName: `Federal College of Forestry Mechanication`,
                            instAddress: `P. M. B. 2273. Afaka. Kaduna.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDCOFOB-IBD`,
                            instName: `Federal College of Forestrv Technology`,
                            instAddress: `P. M. B, 5087, Ibadan, Oyo State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDCOFOR-JOS`,
                            instName: `Federal College of Forestry,`,
                            instAddress: `P. M. B. 2019, Jos, Plateau State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDFISH-LAG`,
                            instName: `Federal College of Fisheries and Marine Technology,`,
                            instAddress: `2, Wilmot Point Road, P. M. B. 80063, victoria siand.Lagos`,
                            instPhone: [``],
                            email: [`info@fcfmt.edu.ng`],
                            website: [`www.icimt.eau.ng`]
                        },
                        {
                            abbreviation: `FEDHORT-GOM`,
                            instName: `Federal College of Horticulture`,
                            instAddress: `P.M.B. 108, Dadin Kowa, Gombe State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FCLT-OWER`,
                            instName: `Federal College of Land Resources Technology, Owerri,`,
                            instAddress: `?.M.B. 1518.Owerri - imo State`,
                            instPhone: [`083-232576`, `083-233889`],
                            email: [`fecolart@hotmail.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `FCLRT-KURU`,
                            instName: `Federal College of Land Resources Technology, Kuru,`,
                            instAddress: `P.M..B. 203 -Jos Plateau State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FMC-AZARE`,
                            instName: `Federal Medical Centre`,
                            instAddress: `Azare, Bauchi State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FMC-NGURU`,
                            instName: `Federal Medical Centre`,
                            instAddress: `iguru, Yobe state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CNS-NGURU`,
                            instName: `College of Nursina sciences. Federal Medical Centre,`,
                            instAddress: `Nauru, Yobe state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FSS-MANCHOK`,
                            instName: `Federal School of Statistics`,
                            instAddress: `P.M.B. 2043, Manchok, Kaduna State.`,
                            instPhone: [`08165456362`, `08030940135`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FSS-IBADAN`,
                            instName: `Federal School of Statistics, ibadan,`,
                            instAddress: `Ibadan, Oyo State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FSS-OVO`,
                            instName: `rederal School ot surveying`,
                            instAddress: `P.M.B. 1024 Oyo State`,
                            instPhone: [`234(0)38-240455`, `240823,2`],
                            email: [`tedsurvevzoobavahoo.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `FSSW-EMENE`,
                            instName: `Federa Schoo of SocIal WOrKS.`,
                            instAddress: `Emene, Enugu State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FEDWILD-NBUS`,
                            instName: `Federal College of Wildlife Management,`,
                            instAddress: `P.M.B. 268. New bussa. Niger State.`,
                            instPhone: [`08033710931`],
                            email: [`into@tcwm.edu.ng`, `wildlifecollege@yahoo.com`],
                            website: [`www.fcwm.edu.ng`]
                        },
                        {
                            abbreviation: `AACNS-AZARE`,
                            instName: `Adamu Adamu College of Nursing Sciences, Federal Medical Centre, Azare.`,
                            instAddress: `Azare. Bauchi State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `IHT-UBTH`,
                            instName: `Institute of Health Technology, UBTH`,
                            instAddress: `Benin City. Edo state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KONGO`,
                            instName: `Institute of Administration, Kongo`,
                            instAddress: `Kongo, Zaria, Kaduna State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MAN-ORON`,
                            instName: `Maritime Academy of Nigeria`,
                            instAddress: `P.M.B. 1089, Oron, Akwa ibom State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MINILS`,
                            instName: `Michael modu National Institute for Labour studies`,
                            instAddress: `Km 7, Ajase-Ipo Road, P.M.B. 1524, ilorin. Kwara state.`,
                            instPhone: [`minils1986@yahoo.com`],
                            email: [`www.minilsnig.org`],
                            website: [``]
                        },
                        {
                            abbreviation: `MISTECHI`,
                            instName: `Meteorological Institute Technology`,
                            instAddress: `Katsina, Katsina State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NACOMEDS`,
                            instName: `Nigerian Army college of Medical ScIences.`,
                            instAddress: `Ojo, Lagos State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NAF-CN`,
                            instName: `Nigerian Air Force College of Nursing Science`,
                            instAddress: `kaduna Kaduna State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NCAT-ZAR`,
                            instName: `Nigerian College of Aviation Technologv.`,
                            instAddress: `Zaria, Kaduna State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NACM`,
                            instName: `Nigeria Army College of Nursing & Midwifery,`,
                            instAddress: `Yaba, Lagos State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NILEST`,
                            instName: `Nigerian Institute of Leather and Science Technology`,
                            instAddress: `P. M. B. 1034, Zaria, Kaduna State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NIMG`,
                            instName: `Nigerian Institute of Mining and Geoscience.`,
                            instAddress: `JOS. Plateau state.`,
                            instPhone: [`Iational Institute for sports. surulere`],
                            email: [`surulere, Lagos State.`],
                            website: [``]
                        },
                        {
                            abbreviation: `NIS`,
                            instName: `Iational Institute for sports. surulere`,
                            instAddress: `surulere, Lagos State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NIHOTOUR`,
                            instName: `National institute Tor hospitality and Tourism Bagauda`,
                            instAddress: `Bagauda Kano State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `INNS-OFFA`,
                            instName: `Nigerian Navy School of Health ScIences.`,
                            instAddress: `Offa, Kwara State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NWRI-MANDO`,
                            instName: `Nationa Water Resources institute.`,
                            instAddress: `vando Road. P.M.B. 2309, Kaduna. Kaduna State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `PTI`,
                            instName: `Petroleum Training Institute`,
                            instAddress: `P.M.B. 20, Effurun, Delta State`,
                            instPhone: [``],
                            email: [`into@pti.edu.ng`],
                            website: [`www.pti.edu.ng`]
                        },
                        {
                            abbreviation: `SBE. ABUTH`,
                            instName: `School of Biomedical Engineering, Ahmad Bello University Teaching Hospital`,
                            instAddress: `Zaria, Kaduna State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SBE-MAID`,
                            instName: `School of Biomedical Engineering. University of Maiduguri Teaching Hospital.`,
                            instAddress: `Maiduguri, Borno State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SBE-UBTH`,
                            instName: `School of Biomedical Engineering, University of Benin Teaching Hospital`,
                            instAddress: `Benin. Edo state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SBE-LUTH`,
                            instName: `Federal School of Biomedical Engineering, Lagos University Teaching Hospital,`,
                            instAddress: `Idi-Araba, Lagos state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SCM-ATBU`,
                            instName: `School of Nursing and Midwifery Abubakar Tatawa Balewa Universitv Teaching Hospital,`,
                            instAddress: `Bauchi, Bauchi State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SHIM-ATBU`,
                            instName: `School of Health Information Management, Abubakar latawa Balewa University Teaching Hospital,`,
                            instAddress: `bauchi, Bauchi State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SN-OAUTHO`,
                            instName: `School of Nursing, Obafemi Awolowo University Teaching Hospital`,
                            instAddress: `Ile-ife Osun state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SN-UBTH`,
                            instName: `School of Nursing, University of Benin Teaching Hospital`,
                            instAddress: `Benin City Edo State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SN-UCTH`,
                            instName: `School of Nursing University of Calabar Teaching Hospital`,
                            instAddress: `Calabar, Cross river State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SOCAST-KAN`,
                            instName: `School of Orthopedic Cast Technologv, Nationa Orthopedic Hospital`,
                            instAddress: `Dala, Kano, Kano State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SOCAST-ENU`,
                            instName: `School of Orthopaedic Cast Technology, National Orthopedic Hospital`,
                            instAddress: `Enugu, Enugu State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SOCAST-ILR`,
                            instName: `School of Orthopaedic Cast Technology, Universitv ot Torn Teaching Hospital.`,
                            instAddress: `ilorin, Kwara State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                    ]
                },
                {
                    id: 6,
                    sectionTitle: `F. STATE MONOTECHNICS`,
                    contents: [
                        {
                            abbreviation: `ANSCOHTECH`,
                            instName: `Anambra state college of Health Technology,`,
                            instAddress: `P.M.B. 1001, Obosi, Anambra State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AUDU-BAKO`,
                            instName: `Audu Bako College of Agriculture`,
                            instAddress: `Danbatta P.M.B. 3159, Kano, Nigeria`,
                            instPhone: [``],
                            email: [`audubako.collegeyahoo.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `BACAF`,
                            instName: `Bala Abduillahi College of Administration,`,
                            instAddress: `Funtud, Katsina state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BYSCOTECH`,
                            instName: `Bayelsa State College of Health Technology,`,
                            instAddress: `P.M.B 131, Yenagoa, Oyuogidi, Ogbia Town, Bayelsa State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CAILS`,
                            instName: `College of Arabic and Islamic Legal Studies`,
                            instAddress: `Ilorin, Kwara State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CHT-ILESA`,
                            instName: `Osun State College of Health Technology`,
                            instAddress: `P.M.B. 5042, Ilesa, Osun State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CHT-ILE-IFE`,
                            instName: `College of Health and Technology, ile-ife.`,
                            instAddress: `ile-ife. Osun State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CHST-JAHUN`,
                            instName: `Jigawa State College of Health Science and Technology,`,
                            instAddress: `Jahun, Jigawa State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CHT-NINGI`,
                            instName: `Bauchi State College of Health Technology,`,
                            instAddress: `Ningi.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CNM-OBUDU`,
                            instName: `College of Nursing and Midwitery, Sciences`,
                            instAddress: `Obudu Cross River State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CLIM`,
                            instName: `Centre for Library and information Management,`,
                            instAddress: `Enugu, Enugu State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CNS-ABEOKUTA`,
                            instName: `Ogun State College of Nursing sCiences.`,
                            instAddress: `Abeokuta, Ogun- State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CNS-BENIN`,
                            instName: `Edo State College of Nursing Sciences`,
                            instAddress: `Benin City, Edo state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CNS-BIDA`,
                            instName: `Niger State College of Nursing Sciences`,
                            instAddress: `bida, Niger State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CNS-SOKOTO`,
                            instName: `Collede of Nursing sciences. Sokoto.`,
                            instAddress: `Sokoto State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CNS-TAMBUWAL`,
                            instName: `College of Nursing Sciences, Tambuwal.`,
                            instAddress: `Sokoto. Sokoto State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CNS-TUDUN WADA`,
                            instName: `Kaduna State College of Nursing sciences.`,
                            instAddress: `Tudun Wada, Kaduna State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CNS-KAFANCHAN`,
                            instName: `Kaduna State College of Nursing sciences.`,
                            instAddress: `Katanchan, Kaduna State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CNS-PAMBEGUA`,
                            instName: `Kaduna State College of Nursing sciences.`,
                            instAddress: `Pambegua, Kaduna State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CNS-ILARO`,
                            instName: `Ogun State College of Nursing ScIences.`,
                            instAddress: `Ilaro Ogun State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CNS-IJEBU-ODE`,
                            instName: `Ogun State College of Nursing ScIences.`,
                            instAddress: `ijebu-Ode. ogun state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CNS-KONTAGORA`,
                            instName: `Niger State College of Nursing Sciences,`,
                            instAddress: `Kontagora, Niger State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CM-JALINGO`,
                            instName: `Taraba State College of Nursing & Midwifery,`,
                            instAddress: `Janlingo Taraba State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CNM-MAIDUGURI`,
                            instName: `Borno State College of Nursing & MIdwitery`,
                            instAddress: `midlaugurt, borno State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CSCNM`,
                            instName: `Cross River State College of Nursing and Midwifery`,
                            instAddress: `Itigidi, Cross RIver State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `COHESKAT`,
                            instName: `Katsina State College of Health Sciences Technology,`,
                            instAddress: `Katsina, Katsina State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BAU-COAGRI`,
                            instName: `Bauchi State College of Agriculture`,
                            instAddress: `P.M.B. 0088, Bauchi`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `COLAGRIC-GAR`,
                            instName: `Plateau State College of Agriculture`,
                            instAddress: `Garkawa, P.M.B. 001, Yelwa, Plateau state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `COLAGRIC-GUJ`,
                            instName: `Yobe State College of Agriculture, GuiDa`,
                            instAddress: `P.M.B. 1104, Damaturu, Yobe State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `COLAGRIC-IGU`,
                            instName: `Edo State College of Agriculture`,
                            instAddress: `P.M.B. 1471, Iguoriakhi,`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `COLAGRIC-JAL`,
                            instName: `College of Agriculture`,
                            instAddress: `P.M.B. 1025. Jalingo Taraba State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `COLAGRIC-KAB`,
                            instName: `College of Agriculture, Kabba, Divisior of Agricultura Colleges. Anmadu bello University`,
                            instAddress: `P M B 205 Kabba Kogi State`,
                            instPhone: [`08036083831`, ``],
                            email: [`collegeofagrickabba@yahoo.com`],
                            website: [`cakab@abu.edu.ng`]
                        },
                        {
                            abbreviation: `COLAGRIC-KAD`,
                            instName: `College of Agriculture and Animal Science`,
                            instAddress: `Mando Road P. M. B. 2134, Kaduna. Kaduna State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `COLAGRIC-LAF`,
                            instName: `College of Agriculture`,
                            instAddress: `P. M. B. 33, Lafia, Nasarawa State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `COLAGRIC-MOK`,
                            instName: `Niger State College of Agriculture`,
                            instAddress: `P. M. B. 109, Mokwa, Niger State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `COLAGRIC-BAK`,
                            instName: `College of Agriculture and Animal Science.`,
                            instAddress: `Bakura P.M.B. 1022, Talata Mafara, Zamfara State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `COLAGBICYAN`,
                            instName: `Akperan Orshi College of Agriculture`,
                            instAddress: `P MB 181 Yandey _ Gboko Benue State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `COLAGBIC-ZUB`,
                            instName: `College of Agriculture`,
                            instAddress: `P M8 1018 Zura Kebbi State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `COHTECH-OFU`,
                            instName: `Delta State College of Health Technology,`,
                            instAddress: `Ofuoma-Uahelli. P.M.B. 22. Ughelli, Delta State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `COTECH-CAL`,
                            instName: `College of Health Technology`,
                            instAddress: `Mary Slessor Avenue, P.M.B. 1324, Calabar. Cross River State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `COTECH-ZAW`,
                            instName: `College of Health Technology`,
                            instAddress: `P.O. Box 2573, Zawan Plateau State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CHST-IDAH`,
                            instName: `collece of Health science and Technology`,
                            instAddress: `Idah. Kogi State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `DSS-MARINE`,
                            instName: `Delta State School of Marine Technology.`,
                            instAddress: `Burutu`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ESUTH`,
                            instName: `Ekiti State University Teaching Hospital College of Nursing Science,`,
                            instAddress: `Ado Ekiti, Ekiti State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FLAILAS`,
                            instName: `Fati Lami Abubakar Institute for Legal & Administrative Studies.`,
                            instAddress: `Minna. Niger-State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `GSCHST-KALTUNGO`,
                            instName: `Gombe State College of Health Sciences and Technology`,
                            instAddress: `Kaltundo, Gombe State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `GSCNM`,
                            instName: `Gombe State Collece of Nursina & Midwifery,`,
                            instAddress: `Gombe State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `COHMSA`,
                            instName: `Imo State College of Health and Management Sciences.`,
                            instAddress: `P.M.B, 2 Amaigbo, Nwangele L.G.A, imo State.`,
                            instPhone: [``],
                            email: [`imconhs@yahoo.com`],
                            website: [`www.imconhs.ng`]
                        },
                        {
                            abbreviation: `JSHITK`,
                            instName: `Jigawa State Institute of Information Technology`,
                            instAddress: `Kazaure, Jigawa State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CNS-BK`,
                            instName: `Jigawa State College of Nursing Sciences`,
                            instAddress: `Birnin Kudu. Jigawa State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CNS-BABURA`,
                            instName: `Jigawa State College of Nursing Sciences.`,
                            instAddress: `Babura, JIgawa state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `JICORAS`,
                            instName: `Jigawa State College of Remedial and Advanced studies.`,
                            instAddress: `Babura, Jigawa State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CNS-HADEJIA`,
                            instName: `Jigawa State college of Nursing Sciences`,
                            instAddress: `Hadela. Jigawa State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KANCOHTECH`,
                            instName: `Kano State College of Health Sciences and Technology`,
                            instAddress: `BUK Road, P.M.B. 3061, Kano, Kano State`,
                            instPhone: [`08130735681`, `09071433891`],
                            email: [`kanohygiene@gmail.com`, `kanonyciene@yahoo.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `•KSCN-KANO`,
                            instName: `Kano State College of Nursing and Midwifery`,
                            instAddress: `Kano, Kano State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KGS-CON`,
                            instName: `Kogi state college of Nursing and Midwifery`,
                            instAddress: `obangede, Kogi State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KSCNM`,
                            instName: `Katsina State College of Nursing & Midwifery`,
                            instAddress: `Katsina, Katsina State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KSCNS`,
                            instName: `Kebbi State College of Nursing ScIences.`,
                            instAddress: `Birnin-Kebbi, Kebbi State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `KWACOHTECH`,
                            instName: `Kwara State College of Health Technology`,
                            instAddress: `Ojoku Road, P.M.B. 430, Ofta, Kwara State.`,
                            instPhone: [`08056432109`, `08105382243`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `COTECH-LG`,
                            instName: `Lagos State College of Health Technology,`,
                            instAddress: `Yaba Lagos State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SN-LUTH`,
                            instName: `school of Nursing, Lagos University Teaching Hospital`,
                            instAddress: `Lagos, Lagos State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SOCAST-LASUTH`,
                            instName: `School of Orthopedic Cast Technology, Lagos State University Teaching Hospital (LASUTH)`,
                            instAddress: `Lagos State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `LASCOCO`,
                            instName: `Lagos State Cooperative College`,
                            instAddress: `Agege, Lagos state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `LASCON`,
                            instName: `Lagos State College of Nursing & Midwifery.`,
                            instAddress: `Igando Lagos state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MLCA-MAI`,
                            instName: `Mahamet Lawan college of Agriculture`,
                            instAddress: `P. M. N. 1427, Maiduguri, Borno State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ODCOHTECH`,
                            instName: `Ondo state college of Health Technology.`,
                            instAddress: `P.M.B. 791, Akure., Ondo State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `OGCOHTECH`,
                            instName: `Ogun State College of Health Technology,`,
                            instAddress: `Ilese-ljebu, P.M.B. 2081, ljebu-Ode, Ogun State.`,
                            instPhone: [`08035531402`, `08034242367`],
                            email: [`cotech06@yahoo.com`],
                            website: [`www.oschotechilese.edu.ng`]
                        },
                        {
                            abbreviation: `OSCNM`,
                            instName: `Ovo State College of Nursina and Midwifery`,
                            instAddress: `Eleyele - Ibadan, Oyo State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `OSCOHST`,
                            instName: `Ovo State College of Health Science and Technology`,
                            instAddress: `Eleyele, Ibadan, Ovo State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SNWGH`,
                            instName: `School of Nursina. Weslev Guilds Hospital, OAUTHC`,
                            instAddress: `Ilesa Osun State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `PSON-VOM`,
                            instName: `Plateau State College of Nursing and Midwifery`,
                            instAddress: `Vom, Plateau State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SSN`,
                            instName: `Shehu Sule Collece of Nursing & Midwifery`,
                            instAddress: `Damaturu. Yobe State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CHT-KEFFI`,
                            instName: `Nasarawa State Colleae of Health Science and Technology`,
                            instAddress: `Keffi Nasarawa State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `ZACAS`,
                            instName: `Zamfara State College of Arts and Science`,
                            instAddress: `P.M.B. 1107, Sanni Abacha Way, Sokoto Road, Gusau, Zamfara State.`,
                            instPhone: [``],
                            email: [`zacas-edu @yahoo.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `ZAMCOHTECH`,
                            instName: `Zamfara State College of Health Science and Technology.`,
                            instAddress: `Tsate, Zamfara State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                    ]
                },
                {
                    id: 7,
                    sectionTitle: `G. PRIVATE MONOTECHNICS`,
                    contents: [
                        {
                            abbreviation: `ADECOM`,
                            instName: `ADECOM College of Business and Management Studies`,
                            instAddress: `Eri-Tosin Mansion, 40, New Adeoyo Hospital Road, Ring Road, Ibadan, Oyo State.`,
                            instPhone: [`08037232137`, `07058709212`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AL-MA'ARIF`,
                            instName: `Al-Ma'arif College of Health Sciences and Technology`,
                            instAddress: `Potiskum, Yobe State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `AMINU-DABO`,
                            instName: `Aminu Dabo College of Health Sciences and Technology.`,
                            instPhone: [`09030808334`, `08121117048`],
                            email: [`info@ad-cohst.edu.ng`],
                            website: [`www.ad-cohst.edu.ng`]
                        },
                        {
                            abbreviation: `ANIMTO`,
                            instName: `A Nations Institute of Marine and Technology`,
                            instAddress: `Oghara Delta State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BABCOHTECH`,
                            instName: `babalola Academy college of Health Technology,`,
                            instAddress: `Ilorin Kwara State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BACOHECH`,
                            instName: `bartholomew college of Health Technology`,
                            instAddress: `Shao, ilorin, Kwara state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `BILL-COHTECH`,
                            instName: `Bill & Melinda Gates College of Health Sciences and Technology,`,
                            instAddress: `Ningi, Bauchi State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CENTCOHTECH`,
                            instName: `Centenary College of Health Technology, Emohua`,
                            instAddress: `Emohua, Port - Harcourt. Rivers state.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CNS-ONITSHA`,
                            instName: `College of Nursing Sciences, St Charles Borromeo Specialist Hospital`,
                            instAddress: `Onitsha, Anambra State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `DAGAMA-COH`,
                            instName: `Dagama's College of Health Technology`,
                            instAddress: `sabon Gari, Zaria, Kaduna State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `DE-POTTER-COH`,
                            instName: `De Potter College of Health Technology`,
                            instAddress: `Oru. Ogun State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            instName: `ED-JOHN`,
                            instAddress: `Ed-Jonn Institute of Management and Technology,`,
                            instPhone: [`Ikorodu, Lagos state`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EMIRATES`,
                            instName: `Emirates College of Health Sciences Technologv,`,
                            instAddress: `Kano. Kano State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `EZEALA`,
                            instName: `Ezeala college of Nursina. sciences`,
                            instAddress: `Umuseke NJaba LGA imo state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `FABOTAS`,
                            instName: `Fabotas College of Health Sciences and Technology`,
                            instAddress: `Ado Ekiti, Ekiti State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `GLOBAL-ND`,
                            instName: `Global Martime Academy of Nigeria.`,
                            instAddress: `Delta, Delta State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `HAMDALA-CNS`,
                            instName: `Hamdala College of Nursing Sciences`,
                            instAddress: `Kano, Kano State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `IITH`,
                            instName: `International Institute of Tourism and Hospitality,`,
                            instAddress: `Yenagoa, Bayelsa State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `IMIT`,
                            instName: `Ihechukwu Madubuike Institute of Technology,`,
                            instAddress: `Isuochi, Abia State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `JAFAD-CNS`,
                            instName: `Jatad College of Nursing Sciences`,
                            instAddress: `Oru ijebu. Ogun State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `JOEMARINE`,
                            instName: `Joemarine instiTute of Nauticar studies and Research,`,
                            instAddress: `Effurun, Delta State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `LAPO`,
                            instName: `LAPO Institute for Microfin lance and Enterprise Development,`,
                            instAddress: `benin, Edo State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MALIKIYA`,
                            instName: `Malikiya college of Health and Social Sciences.`,
                            instAddress: `Bauchi, 9, Gombe Road, Off Sokoto Road Old GRA, Bauchi State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MLN-COTECH`,
                            instName: `Millennium College of Health Technology`,
                            instAddress: `Akure. Ondo State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MTI`,
                            instName: `Metallurgical Training Institute, Onitsha`,
                            instAddress: `KM. 6/7 Onitsha - Owerri Rd, P.M.B. 1555, Anambra State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `MUSON`,
                            instName: `Muson schooL of Music.`,
                            instAddress: `Marina Onikan, Lagos State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NIHST`,
                            instName: `Nazareth Institute of Health Science & Technology`,
                            instAddress: `Makurdi, Benue State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NIJ`,
                            instName: `Nigerian Institute of Journalism,`,
                            instAddress: `Lateef Jakande House. 8 - 14. liaive Road. Oaba Estate. Ikeia Lagos slate.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NGCHTECH`,
                            instName: `New Gate College of Health Technology`,
                            instAddress:`Minna. Niger State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `NKST-COTECH`,
                            instName: `NKST College of Health Technology`,
                            instAddress: `P.M.B. 206, Gboko, Benue State.`,
                            instPhone: [``],
                            email: [`nkstchmkarmkar@yahoo.com`],
                            website: [`www.nkstchtmkar.org`]
                        },
                        {
                            abbreviation: `OAK`,
                            instName: `OAK bUsiness School`,
                            instAddress: `River View Estate, Ogun State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `PECOHSTECH`,
                            instName: `Peaceland College of Health Sciences and Technology,`,
                            instAddress: `Enugu, Enugu State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `PEMGO-COL`,
                            instName: `Pemgo College of Business and Management Studies LTD KarU L.G.A Nasarawa State.`,
                            instAddress: ``,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `POGIL`,
                            instName: `Pogil College of Health technology`,
                            instAddress: `Oke-Eri, ljebu-Ode, Ogun state`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SAVANNAH`,
                            instName: `Savannah Institute of Technology`,
                            instAddress: `Abakaliki, Ebonyi State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SLDCT-AKTH`,
                            instName: `School of Laundry and Dry Cleaning Technology`,
                            instAddress: `Aminu Kano Teaching Hospital, Kano, Kano State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SN-AMICHI`,
                            instName: `School of Nursing Diocesan Hospital.`,
                            instAddress: `Amichi Anambra State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `CNS-AMICHI`,
                            instName: `College of Nursing Sciences, Amichi`,
                            instAddress: `Nnewi South, Anambra State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `TCHST`,
                            instName: `Tropical College of Health Sciences & Technology,`,
                            instAddress: `Kano, Kano State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `USTEEM`,
                            instName: `Usteem College of Agriculture`,
                            instAddress: `Osogbo, Osun State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `WAVECREST`,
                            instName: `WAVECREST College of Hospitality, Lagos`,
                            instAddress: `75 Adisa Bashua Street, off Adelabu Street, Surulere P. O. Box 602, Surulere Post Office, Lagos.`,
                            instPhone: [`01-4545972`, `08083964840`, `08033322414`],
                            email: [`into@wavecrest.edu.ng`],
                            website: [`www.wavecrest.edu.ng`]
                        },
                    ]
                },
                {
                    id: 8,
                    sectionTitle: `H. COLLEGE OF HEALTH SCIENCES`,
                    contents: [
                        {
                            abbreviation: `ABUTH`,
                            instName: `Ahmadu Bello University Teaching Hospital`,
                            instAddress: `P.M.B. 06, Shika, Zaria, Kaduna State`,
                            instPhone: [`069-550098]`, `551399`],
                            email: [`macoabuth@yahoo.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `AKNTH`,
                            instName: `Aminu Kano Teaching Hospital, School of Health Information Management,`,
                            instAddress: `P.M.B. 3452, Kano Kano State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `SHIM-LUTH`,
                            instName: `schoo ot Health intormation Management, Lagos University Teaching Hospital,`,
                            instAddress: `P.M.B. 12003, Idi-Araba, Lagos, Nigeria.`,
                            instPhone: [`08032482727`, `08023281578`, `08033825813`],
                            email: [`shrabluth@yahoo.co.uk`],
                            website: [``]
                        },
                        {
                            abbreviation: `OAUTHC`,
                            instName: `School of Health Information Management, (Obafemi Awolowo University Teaching Hospital complex`,
                            instAddress: `P.M.B. 5538, ile-ife. Osun State.`,
                            instPhone: [`081520092751`, `08152092755`, `08152092999`, `08035215763`,`09093971040`],
                            email: [`adediranfoluks@gmail.com`, `info@oauthc.com`],
                            website: [`www.oauthc.com`]
                        },
                        {
                            abbreviation: `SHEHU IDRIS`,
                            instName: `Shehu Idris College of Health Sciences and Technology, Makarfi`,
                            instAddress: `P.M.B. 1050, Makarti. Kaduna State.`,
                            instPhone: [`08020971682`],
                            email: [`sichstmz0b@vanoo.com,`],
                            website: [`sichstm2005@ hotmail.com`]
                        },
                        {
                            abbreviation: `SHIM-UBTH`,
                            instName: `School of Health Information Management. (University of Benin Teaching Hospital)`,
                            instAddress: `P.M.B. 1111, Benin City, Edo State.`,
                            instPhone: [`08063921117`, `08189165299`],
                            email: [`kygbon@yahoo.com`],
                            website: [`www.ubth.org`]
                        },
                        {
                            abbreviation: `SHIM-UCH`,
                            instName: `School of Health Information Management, University College Hospital,`,
                            instAddress: `P. M.B. 5116, ibadan.`,
                            instPhone: [`+234-2-8093910763`],
                            email: [`shimuchibadan@yahoo.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `SHIM-UDUTH`,
                            instName: `School of Health Information Management, University College Hospital,`,
                            instAddress: `P. M.B. 5116, Ibadan.`,
                            instPhone: [`+234-2-8093910763`],
                            email: [`shimuchibadan@yahoo.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `SHIM-UDUTH`,
                            instName: `School ot Health Information Management, Usmanu Dantodiyo University Teaching Hospital,`,
                            instAddress: `P.M.B. 2370, Sokoto`,
                            instPhone: [``],
                            email: [`shimuduth @ gmail.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `SHIM-UMTH`,
                            instName: `School of Health Information Management University of Maiduguri Teaching hospital`,
                            instAddress: `P.M.B. 1414, Maiduguri, Borno State.`,
                            instPhone: [``],
                            email: [`cmd umth@yahoo.com`, `shImumth@vanoo.com`],
                            website: [``]
                        },
                        {
                            abbreviation: `SHIM-UNILORIN`,
                            instName: `University of Ilorin Teaching Hospital, School of Health Information Management.`,
                            instAddress: `Old Jebba Road, P.M.B. 1459 llorin, Kwara State.`,
                            instPhone: [`08055763942`, `08037301311`],
                            email: [`unithilorin1980 @ yahoo.com`],
                            website: [`info @uith.org`]
                        },
                        {
                            abbreviation: `SHIM-UYOTH`,
                            instName: `School of Health Information Management, University of Uyo Teaching Hospital`,
                            instAddress: `P.M.B. 1136 Uyo, Akwa Ibom State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UNICALTH`,
                            instName: `University of Calabar Teaching Hospital, School of Health Information Management`,
                            instAddress: `P.M.B. 1278, Calabar, Nigeria.`,
                            instPhone: [`087-232055`, `087-232408-9`],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UNIPORT-TH`,
                            instName: `University of Port Harcourt Teaching Hospital`,
                            instAddress: `Port Harcourt, Rivers State.`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                        {
                            abbreviation: `UNIZIKTH`,
                            instName: `School of Health Information Management, Nnamdi Azikiwe University Teaching Hospital`,
                            instAddress: `P.M.B. 5025 Nnewi, Anambra State`,
                            instPhone: [``],
                            email: [``],
                            website: [``]
                        },
                    ]
                },
            ]
        },
    ]
 }
]